module.exports = __webpack_public_path__ + "img/userBlue.6e1da276.png";